// extracted by mini-css-extract-plugin
module.exports = {"navItem":"styles_navItem__MQxe7","title":"styles_title__VtTfN","description":"styles_description__ti58Y"};